// Products.js
import React from "react";
import "./Products.css";

function Products({ imageSrc, name, description, packSize, price }) {
  return (
    <>
      <div className="product">
        <img src={imageSrc} alt="" />
        <div className="product-body">
          <h5 style={{color:'#003b82'}}>{name}</h5>
          <p>{description}</p>
          <p>{packSize}</p>
          <p style={{ marginTop: "4%", fontSize: "16px" }}>{price}</p>
          <button style={{cursor:'pointer'}}>Add to cart</button>
        </div>
      </div>
    </>

  );
}

export default Products;
